import React                   from 'react';
import {
    useLocation,
    useNavigate,
    Location,
    NavigateFunction
}                              from 'react-router-dom';

import MenuItem                from 'components/MenuItem';
import getApiPromise           from 'utils/getApiPromise';

interface Props {
    location?: Location;
    navigate: NavigateFunction;
}

interface State {
    replyText: string;
    replySubject: string;
    status: string;
}

class ReplyForm extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            replyText: '',
            replySubject: '',
            status: ''
        };
    }

    handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        this.setState({ replyText: e.target.value });
    };

    handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const selectedMessage = this.props.location?.state?.selectedMessage;
        const result = {
            id      : selectedMessage._id,
            message : this.state.replyText,
            subject : this.state.replySubject,
            mail    : selectedMessage.submitterEmail
        }
        if(typeof result.subject !== 'string' || result.subject.length > 256) {
            this.setState({ status: "Subject too long or invalid"});
            return;
        }
        if(typeof result.message !== 'string' || result.message.length > 4096 ) {
            this.setState({ status: "Message too long or invalid"});
            return;
        }
        getApiPromise('/api/dispatcher/feedback','POST', result)
            .then( res => {
                if( !res || res.err )
                    throw Error(res?.err||'result is empty');
                if(res.acknowledged === true){
                    this.props.navigate(`/Dispatcher/Feedback`);
                }
                else{this.setState({ status: "Server Error"})}
            })
            .catch( err => {
                this.setState({status:`Cannot save feedback (${(err as Error).message})`});
            });
    };

    render() {
        const selectedMessage = this.props.location?.state?.selectedMessage;
        const email = selectedMessage?.submitterEmail || '';
        const subject = selectedMessage?.subject || '';
        const message = selectedMessage?.message || '';
        return (
            <form onSubmit={this.handleSubmit}>
                <div style={{
                    maxWidth: '600px',
                    margin: '40px auto',
                    padding: '24px',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
                }}>
                    <div style={{ marginBottom: '16px' }}>
                        <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px' }}>Email:</label>
                        <input
                            className   = "input-theme input-theme-min"
                            type        = "email"
                            value       = {email}
                            disabled
                            style       = {{
                                width: '100%',
                                padding: '10px',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                background: '#f0f0f0'
                            }}
                        />
                    </div>
                    <div style={{ marginBottom: '16px' }}>
                        <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px' }}>Subject:</label>
                        <input
                            className   = "input-theme input-theme-min"
                            type        = "text"
                            value       = {subject}
                            disabled
                            style       = {{
                                width: '100%',
                                padding: '10px',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                background: '#f0f0f0'
                            }}
                        />
                    </div>
                    <div style={{ marginBottom: '16px' }}>
                        <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px' }}>Message:</label>
                        <textarea
                            rows        ={5}
                            className   = "input-theme input-theme-min"
                            value       = {message}
                            disabled
                            style       = {{
                                width: '100%',
                                height: '100%',
                                padding: '10px',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                background: '#f0f0f0',
                                resize: 'none'
                            }}
                        />
                    </div>
                    <div style={{ marginBottom: '16px' }}>
                        <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px' }}>Reply Subject:</label>
                        <input
                            required
                            className = "input-theme input-theme-min"
                            style     = {{
                                width: '100%',
                                padding: '10px',
                                border: '1px solid #ccc',
                                borderRadius: '4px'
                            }}
                            type      = "text"
                            value     = {this.state.replySubject}
                            onChange  = {(e) => this.setState({ replySubject: e.target.value })}
                        />
                    </div>
                    <div style={{ marginBottom: '16px' }}>
                        <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px' }}>Reply Message:</label>
                        <textarea
                            required
                            className   ="input-theme input-theme-min"
                            style       = {{
                                width: '100%',
                                padding: '10px',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                resize: 'none',
                                height: '100%'
                            }}
                            value       = {this.state.replyText}
                            onChange    = {this.handleChange}
                            rows        = {5}
                        />
                    </div>
                    <button
                        type      = "submit"
                        className = "btn-theme"
                    >
                        Send Reply
                    </button>
                    {this.state.status && (
                        <p style={{ marginTop: '20px', fontWeight: 'bold' }}>{this.state.status}</p>
                    )}
                </div>
            </form>
        );
    }
}

export default function Reply() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <MenuItem title="Reply">
      <ReplyForm location={location} navigate={navigate} />
    </MenuItem>
  );
}
